import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import * as S from './styles';
import { IUserType } from '@state/auth/types';
import Layers from '../../Layers'
import Tabs from '@components/Tabs';
import ZIndexStack from '../../ZIndexStack';

const LAYER_STRUCTURE_OPTIONS = ["LAYERS", "STACKS"];

const LayersPicker:React.FC<IProps> = (props) => {      

    const authContext = useContext(AuthContext);
    const isAdmin = authContext.userData.profile.role === IUserType.ADMIN;

    const [layersStructureOptions, setLayersStructureOptions] = useState(LAYER_STRUCTURE_OPTIONS);
    const [layerOptionValue, setLayerOptionValue] = useState(LAYER_STRUCTURE_OPTIONS[isAdmin ? 0 : 1]);

    return (
        <S.Root>
          {
            isAdmin &&
            <Tabs
              value={layerOptionValue}
              setValue={setLayerOptionValue}
              options={layersStructureOptions}
              sizes={{tabWidth: 117.5}}
              containerStyle={{padding: `0px 14px`, boxSizing: `border-box`}}
            />
          }
          { (isAdmin && layerOptionValue === LAYER_STRUCTURE_OPTIONS[0]) &&
            <Layers/>
          }
          { layerOptionValue === LAYER_STRUCTURE_OPTIONS[1] &&
            <ZIndexStack />
          }
        </S.Root>
    );

}

export default LayersPicker;